import script from "./Products-Data-Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Products-Data-Editor.vue?vue&type=script&setup=true&lang=js"

import "./Products-Data-Editor.vue?vue&type=style&index=0&id=62537052&lang=css"
import "./Products-Data-Editor.vue?vue&type=style&index=1&id=62537052&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62537052"]])

export default __exports__